import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { Referral } from 'api/types/referrals'

interface ReferralsListCacheState {
  entries: Record<string, Referral[]>
  getUsers: (tab: string) => Referral[]
  setUsers: (tab: string, users: Referral[]) => void
  clearTab: (tab: string) => void
  clearAll: () => void
}

const makeKey = (tab: string) => `tab:${tab.trim().toLowerCase()}`

export const useReferralsListCacheStore = create<ReferralsListCacheState>()(
  persist(
    (set, get) => ({
      entries: {},

      getUsers: (tab) => get().entries[makeKey(tab)] ?? [],

      setUsers: (tab, users) => {
        const key = makeKey(tab)

        set(state => ({
          entries: {
            ...state.entries,
            [key]: users,
          },
        }))
      },

      clearTab: (tab) => {
        const key = makeKey(tab)

        set(state => {
          const next = { ...state.entries }
          delete next[key]

          return { entries: next }
        })
      },

      clearAll: () => set({ entries: {} }),
    }),
    {
      name: 'referrals-list-cache-v1',
      partialize: state => ({ entries: state.entries }),
    }
  )
)